import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const createRegistration = (payload) => api.post("/registrations", payload).then((r) => r.data);
export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const submitInquiry = (payload) => api.post("/inquiries", payload).then((r) => r.data);
export const createCheckoutSession = (registrationId) =>
  api.post("/checkout/session", { registration_id: registrationId, origin_url: window.location.origin }).then((r) => r.data);
export const getCheckoutStatus = (sessionId) => api.get(`/checkout/status/${sessionId}`).then((r) => r.data);
export const getPublicConfig = () => api.get("/config").then((r) => r.data);
export const getRegistrationStatus = () => api.get("/registration-status").then((r) => r.data);
export const getSiteContent = () => api.get("/site-content").then((r) => r.data);
export const submitOrgInquiry = (payload) => api.post("/org-inquiries", payload).then((r) => r.data);

export const adminLogin = (password) => api.post("/admin/login", { password }).then((r) => r.data);
export const adminFetch = (path, password) =>
  api.get(path, { headers: { "X-Admin-Password": password } }).then((r) => r.data);
export const adminPut = (path, password, body) =>
  api.put(path, body, { headers: { "X-Admin-Password": password } }).then((r) => r.data);
export const adminPost = (path, password, body) =>
  api.post(path, body || {}, { headers: { "X-Admin-Password": password } }).then((r) => r.data);
export const adminPatch = (path, password, body) =>
  api.patch(path, body, { headers: { "X-Admin-Password": password } }).then((r) => r.data);
export const adminDelete = (path, password) =>
  api.delete(path, { headers: { "X-Admin-Password": password } }).then((r) => r.data);
